export class BOMHeader {
  public constructor(
    public material: string,
    public plant: string,
    public usage: string,
    public altBom: string,
    public status: number
  ) {}
}
